import articleChannelNeedsTakedown from "astrid-firestore/src/api/articles/articleChannelNeedsTakedown";

export default function shouldDoTakedownOrDisable({ article, channel }) {
	if (!article.channelIds?.includes(channel.id)) {
		return "ENABLE";
	}

	return articleChannelNeedsTakedown({ article, channel }) ? "TAKEDOWN" : "DISABLE";
}
